import { SyntheticEvent, useCallback } from 'react';

const useStopPropagation = <E extends SyntheticEvent>(callback?: (e: E) => unknown) => {
  return useCallback(
    (e: E) => {
      e.stopPropagation();
      return callback?.(e);
    },
    [callback]
  );
};

export default useStopPropagation;
